export default "__VITE_ASSET__d7KNwkFI__"